export { aboutMapper } from './aboutMapper/aboutMapper'
export { categoryMapper } from './categorymapper/categoryMapper'
export { commentMapper } from './commentMapper/commentMapper'
export { mediaMapper } from './mediaMapper/mediaMapper'
export { postMapper } from './postMapper/postMapper'
export { writerMapper } from './writterMapper/writerMapper'
